import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import './slick-carousel';
import 'jquery-zoom';
import createCounter from './slick/counter';
// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'slides';

export const SLICK_CLASS = 'js-slides-slick';
export const STATUS_CLASS = 'js-slides-status';

export const DEFAULTS = {
  slidesToShow: 1,
  showStatus: false,
  lazyLoad: 'ondemand',
  arrows: true,
  delay: 1000,
  showZoomTab: false,
  productZoomBtn: '.product-zoom__btn',
  productZoomBtnActive: 'product-zoom__btn--active',
  adjacentSlidesBorder: false, // https://revolve.atlassian.net/browse/AB-586
};

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - slides wrap
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
const mergeOptions = ($el, options = {}) => {
    return Object.assign({}, DEFAULTS, $el.data(), options);
};

const zoomHover = ($zoomContainer, opts) => {
  const zoomImg = '.zoomImg';
  const delay = opts.delay;
  const hideClass = 'u-hide';
  let timer;
  $zoomContainer.hover(function() {
    timer = setTimeout(function() {
      $zoomContainer.find(zoomImg).removeClass(hideClass);
    }, delay);
  }, function() {
    clearTimeout(timer);
    $zoomContainer.find(zoomImg).addClass(hideClass);
  });
}

const initZoom = ($slidesWrap, opts) => {
  const $zoomContainer = $slidesWrap.find('.slick-active').find('.js-pdp-image-zoom');
  const zoomImgUrl = $zoomContainer.data('zoom-img');
  const hasActiveClass = $zoomContainer.hasClass('zoom-active');

  if (!hasActiveClass) {
    $zoomContainer.zoom({
      url: zoomImgUrl,
      callback: function() {
        $(this).addClass('u-hide');
      }
    });
    $zoomContainer.addClass('zoom-active');
  }
  zoomHover($zoomContainer, opts);
}

const triggerZoom = ($slidesWrap, $slides, opts) => {
  $slides
    .on('init', (event, slick, currentSlide, nextSlide) => {
      initZoom($slidesWrap, opts)
      a11yKeyboardTriggerZoom($slidesWrap);
    })
    .on('afterChange', (event, slick, currentSlide, nextSlide) => {
      initZoom($slidesWrap, opts);
      a11yKeyboardTriggerZoom($slidesWrap);
    });
}

const a11yKeyboardTriggerZoom = ($slidesWrap) => {
  $slidesWrap.find('.pdp__image').removeAttr('tabindex');
  $slidesWrap.find('.slick-active .pdp__image').attr('tabindex', '0');
}

const initSlick = ($slidesWrap, $slides, opts) => {
    if(opts.showStatus) {
      createCounter($slidesWrap);
    }
    if (!$('html').hasClass('touch') && opts.zoomImg) {
      triggerZoom($slidesWrap, $slides, opts);
    }
    if (opts.adjacentSlidesBorder) {
      outlineAdjacentSlides($slides);
    }
    $slides.slick(opts);
    if ($slides.find('video').length) {
      videoA11y($slides);
    }
}
/**
 * Adds border class to the nav slides matching the images currently visible in
 * the main carousel. https://revolve.atlassian.net/browse/UX-21082
 *
 * Driven off the main carousel because the nav is `infinite: false` — when the
 * main carousel wraps past its last slide, slick clamps the nav and re-fires
 * the nav's `afterChange` with its previous (stale) index.
 * @param {Object} navSlick - slick instance for the nav (thumbnails)
 * @param {Object} mainSlick - slick instance for the main carousel
 */
const outlineVisibleNavSlides = (navSlick, mainSlick) => {
  const BORDER_CLASS = 'border-current';
  const navSlideCount = navSlick.slideCount;
  if (!navSlideCount) {
    return;
  }
  // main's options.slidesToShow already reflects the active breakpoint
  const slidesShowing = Math.min(
    mainSlick.options.slidesToShow, mainSlick.slideCount, navSlideCount);
  navSlick.$slideTrack.find('.slick-slide').removeClass(BORDER_CLASS);
  for (let i = 0; i < slidesShowing; i += 1) {
    const navIndex = (mainSlick.currentSlide + i) % navSlideCount;
    $(navSlick.$slides.get(navIndex)).addClass(BORDER_CLASS);
  }
};

const outlineAdjacentSlides = ($slides) => {
  const resetPosition = (moreSlidesThanSlideToShow) => {
    $slides.on('setPosition', function(event) {
      if(!moreSlidesThanSlideToShow) {
        $(event.currentTarget).find('.slick-track').css({transform: `translate3d(0px, 0px, 0px)`});
      }
    });
  }

  $slides.on('init', function(event, navSlick) {
    const $mainSlickCarousel = $(navSlick.originalSettings.asNavFor);
    resetPosition(navSlick.slideCount > navSlick.options.slidesToShow);
    if (!$mainSlickCarousel.hasClass('slick-initialized')) {
      return;
    }
    outlineVisibleNavSlides(navSlick, $mainSlickCarousel.slick('getSlick'));
    // both events pass the main slick instance as their first extra arg;
    // `breakpoint` fires after slick swaps in the new options, so
    // slidesToShow is already up to date by the time we read it
    $mainSlickCarousel.on('afterChange breakpoint', function(mainEvent, mainSlick) {
      outlineVisibleNavSlides(navSlick, mainSlick);
    });
  });
};
/**
  * remove active class to hide btn
  */
 const hideBtn = (opts) => {
   opts.$btn.removeClass(opts.productZoomBtnActive);
   opts.$btn.one('transitionend', function() {
     opts.$btn.hide();
   });
 }

 /**
   * add active class to show btn
   */
 const showBtn = (opts) => {
  opts.$btn.addClass(opts.productZoomBtnActive);
}

/**
  * show and hide button on load
  */
 const toggleProductZoomBtn = (opts) => {
  opts.$btn = $(opts.productZoomBtn); // cache once, reuse downstream
  showBtn(opts);
  setTimeout(function(){
    hideBtn(opts);
  }, 1500);
}

/**
 * Adds and removes tabindex and aria-hidden based on slide being active
 * @param {jQuery} $slides - the slides to iterate over
 */
const videoA11y = $slides => {
  $slides.find('.slick-slide').each(function() {
    const $slide = $(this);
    const $video = $slide.find('video');

    if (!$slide.hasClass('slick-active')) {
      $video.attr({
        tabIndex: '-1',
        'aria-hidden': 'true',
      });
    }
  });

  $slides.on('afterChange', (event, slick, currentSlide) => {
    $slides.find('.slick-slide').each(function() {
      const $slide = $(this);
      const $video = $slide.find('video');

      if ($slide.hasClass('slick-active')) {
        $video.attr({
          tabIndex: '0',
          'aria-hidden': 'false',
        });
      }
    });
  });
};

/**
 * Initializes slides
 * @param {HTMLElement} el - tab link
 * @param {Object} [options] - Object containing override options
 */
export default function slides(el, options = {}) {
    const $slidesWrap = $(el);
    const $slides = $slidesWrap.find(`.${SLICK_CLASS}`);
    const opts = mergeOptions($slidesWrap, options);
    initSlick($slidesWrap, $slides, opts);
    if(opts.showZoomTab) {
      toggleProductZoomBtn(opts);
    }
}

registerJQueryPlugin(PLUGIN_NAME, slides);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slides.js